<script setup lang="ts">
import { computed } from 'vue';
import { useAiProfileValidation } from '@apparatix/composables';
import { Typography } from '@apparatix/library/core';
import { Content } from '@apparatix/types/AccountProfiles';
import InvalidProfileContent from './InvalidProfileContent.vue';

type Props = {
  contents: Content<'list'>;
  columns?: string[];
}

const props = defineProps<Props>();

const { validateListSchema } = useAiProfileValidation();

const isEmpty = computed(() => !props.contents);
const isValidSchema = computed(() => validateListSchema(props.contents, props.columns));

const renderItem = (item: string | object): string => {
  if (typeof item === 'string') {
    return item;
  }

  const [key] = props.columns;
  return item[key];
};
</script>
<template>
  <ul v-if="isValidSchema" class="list-disc list-inside">
    <Typography
      v-for="(item, idx) in props.contents"
      :key="idx"
      variant="list-item"
    >
      {{ renderItem(item) }}
    </Typography>
  </ul>
  <InvalidProfileContent v-if="!isValidSchema" :empty="isEmpty" />
</template>
